import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

export function SortableCredit({ id, children }) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div style={{ display: "flex", alignItems: "center" }}>
        
        {/* HANDLE */}
        <span
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
            padding: "6px",
            display: "flex",
            alignItems: "center",
            touchAction: "none"
          }}
        >
          <DragIndicatorIcon fontSize="small" />
        </span>

        <div style={{ flex: 1 }}>
          {children}
        </div>
      </div>
    </div>
  );
}